import { render, staticRenderFns } from "./MyTaskboard.vue?vue&type=template&id=faf9cb02&"
import script from "./MyTaskboard.vue?vue&type=script&lang=js&"
export * from "./MyTaskboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports